// Dock has its own fixed set of widgets for one hardcoded rc-dock layout —
// nothing else in the app enumerates "all dock widgets", so this is just a
// plain module of instances, not a registry (unlike dashboard-widgets.ts /
// tabs-widgets.ts, which back id-based lookups shared across consumers).
import { WidgetDockAdapter } from '@/app/dock/widget-dock-adapter';
import { DataCalendarWidget, HotListWidget } from '@/modules/calendar/export';
import { BulletListWidget, SearchWidget } from '@/modules/articles/export';

export const fiWidget = new WidgetDockAdapter(
  'fi',
  new BulletListWidget('fi-bullets', ['fi-bullets'], { title: 'FI Bullets' }, 'FI'),
);
export const fxWidget = new WidgetDockAdapter(
  'fx',
  new BulletListWidget('fx-bullets', ['fx-bullets'], { title: 'FX Bullets' }, 'FX'),
);
export const allBulletsWidget = new WidgetDockAdapter(
  'all-bullets',
  new BulletListWidget('all-bullets', ['all-bullets'], { title: 'All Bullets' }, 'All'),
);
export const calWidget = new WidgetDockAdapter('calendar', new DataCalendarWidget());
export const hotWidget = new WidgetDockAdapter('hot-list', new HotListWidget());
export const searchWidget = new WidgetDockAdapter('search', new SearchWidget());

export const widgets = [calWidget, hotWidget, allBulletsWidget, fiWidget, fxWidget, searchWidget];
